import React, {
  useRef,
  MutableRefObject,
  createContext,
  useState,
  ReactNode,
  useMemo,
  Dispatch,
  SetStateAction,
} from 'react';
import { scrollToY } from '../utils';

export const SectionContext = createContext<ISectionContext>(null);
interface SectionContextProviderProps {
  children: ReactNode;
}

export const SectionContextProvider = (
  props: SectionContextProviderProps,
) => {
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const elements = useRef<HTMLElement[]>([]);

  const registerElement = (
    ref: MutableRefObject<HTMLElement>,
  ): void => {
    elements.current = [...elements.current, ref.current];
  };

  const scrollToIndex = (index: number): void => {
    const element = elements.current[index];

    if (!element) {
      return;
    }

    const top = Math.max(0, element.offsetTop - 80);

    scrollToY(top);
  };

  const value = useMemo(
    () => ({
      activeSectionIndex,
      setActiveSectionIndex,
      registerElement,
      scrollToIndex,
    }),
    [activeSectionIndex],
  );

  return (
    <SectionContext.Provider value={value}>
      {props.children}
    </SectionContext.Provider>
  );
};

type ISectionContext = null | {
  activeSectionIndex: number;
  setActiveSectionIndex: Dispatch<SetStateAction<number>>;
  registerElement: (ref: MutableRefObject<HTMLElement>) => void;
  scrollToIndex: (index: number) => void;
};
